import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Close: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666' }) => (
  /*@ts-ignore*/
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0009 10.5867L19.2928 3.29298C19.6833 2.90241 20.3165 2.90233 20.707 3.29281C21.0976 3.68329 21.0977 4.31645 20.7072 4.70702L13.4151 12.0009L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L12.001 13.4153L4.70719 20.7108C4.31671 21.1014 3.68355 21.1015 3.29298 20.711C2.90241 20.3205 2.90233 19.6874 3.29281 19.2968L10.5868 12.001L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L12.0009 10.5867Z"
      fill={fill}
    />
  </svg>
);

export default Close;
